export default {
  path: '/care-label',
  component: () => import('@/views/printCareLabel/index.vue'),
  children: [
    {
      path: '',
      name: 'PrintCareLabel',
      component: () => import('@/views/printCareLabel/pages/PrintCareLabel.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'accounting_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    }
  ]
}
